<header class="header-panel">
    <nav class="navbar navbar-expand-lg fixed-top shadow-sm bg-white patent-plus-logo patent-plus-design">
        <div class="header-main-panel" id="navbarToggle">
            <div class="center-panel" *ngIf="logoPath != undefined">
                <a class="navbar-brand">
                    <img id="imgLogo" src={{logoPath}} />
                    <span class="version-text">{{this.appVersion}}</span>
                </a>
            </div>
        </div>
    </nav>
</header>

<form class="form-horizontal" [formGroup]="documentForm">
  <div style="height:30px"></div>
  <div class="card">
    <div class="card-header">
      <div style="float:left">
        <h3>{{panelTitle}}</h3>
      </div>
      <div style="float:right">
      </div>
    </div>
    <div class="card-body">
      <div class="col-sm-8 float-sm-left">
        <div class="card box">
          <br />
          <div class="container-fluid container-fluid-more">
            <div class="row txt_row">
              <p>Thank you for submitting Record Of Invention.</p>
            </div>
            <div class="row txt_row">
              <p>You may close your browser.</p>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div class="card-footer controlset">
      <div class="container-fluid">
        <div class="row">
          <div class="btn-group btn-group-sm col-sm-2">
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
